export { ColorsPalette as BeesafeColorsPalette } from './tenants/beesafe/colors.palette';
export { theme as beesafeTheme } from './tenants/beesafe/theme';
export { ColorsPalette as BenefiaColorsPalette } from './tenants/benefia/colors.palette';
export { theme as benefiaTheme } from './tenants/benefia/theme';
export { ColorsPalette as CompensaColorsPalette } from './tenants/compensa/colors.palette';
export { theme as compensaTheme } from './tenants/compensa/theme';
export { ColorsPalette as InterriskColorsPalette } from './tenants/interrisk/colors.palette';
export { theme as interriskTheme } from './tenants/interrisk/theme';
export { ColorsPalette as GapColorsPalette } from './tenants/gap/colors.palette';
export { theme as gapTheme } from './tenants/gap/theme';
export { ColorsPalette as TuwColorsPalette } from './tenants/tuw/colors.palette';
export { theme as tuwTheme } from './tenants/tuw/theme';
export { ANIMATIONS, BREAKPOINTS, MEDIA_QUERY } from './utils/index';
